<template>
  <v-highlight
    v-if="product"
    :header="$section.sectionHeader"
    :product="product"
    class="c-highlight--banner"
  >
    <h2 class="o-typography__headline2 u-bold">
      {{ product.title }}
    </h2>
    <v-badge
      :product="product"
      class="c-highlight__badge"
      :counting="isFuture"
    ></v-badge>
    <p class="o-typography__body1 u-desktop-only">
      {{ product.lead | truncate }}
    </p>
    <template #buttons>
      <v-product-redirect
        :product="product"
        :show-label="true"
      ></v-product-redirect>
    </template>
  </v-highlight>
</template>
<script>
  import { SectionContentType } from '@/shared/enums';
  import { VBadge, VHighlight, VProductRedirect } from '@/index/shared/components';
  import { truncate } from '@/index/shared/filters';
  import { productMixin } from '@/index/shared/mixins';
  import { randomProductMixin } from '@/index/components/section/mixins';
  import Banners from '@/shared/libs/sdk/banners/banners';

  export default {
    components: {
      VBadge,
      VHighlight,
      VProductRedirect,
    },
    filters: {
      truncate,
    },
    mixins: [
      productMixin,
      randomProductMixin,
    ],
    data() {
      return {
        banners: new Banners(),
        sectionId: this.$section.resource.id,
      };
    },
    computed: {
      isRecommendation() {
        return this.$section.resource.contentType === SectionContentType.RECOMMENDATION;
      },
    },
    created() {
      if (this.isRecommendation) {
        this.$EventBus.on('ipressoDisplayBanner', this.displayBanner);
      }
    },
    beforeDestroy() {
      if (this.isRecommendation) {
        this.$EventBus.off('ipressoDisplayBanner', this.displayBanner);
      }
    },
    methods: {
      displayBanner({ sectionId, bannerId }) {
        if (sectionId !== this.sectionId || !bannerId) {
          return;
        }

        this.banners.fetch(bannerId).then(() => {
          this.product = this.banners.get(bannerId);
        });
      },
    },
  };
</script>
